import { EventHandler } from '../event-handler'

export class EventSpaceKeyAppender extends EventHandler {
  /**
   * @param {string} spaceKey
   */
  constructor(spaceKey) {
    super()
    this.spaceKey = spaceKey
  }

  /**
   * @param {import('../event').Event} event
   */
  handle(event) {
    const currentPayload = event.getPayload()
    const updatedPayload = {
      ...currentPayload,
      spaceKey: this.spaceKey,
    }
    event.setPayload(updatedPayload)

    super.handle(event)
  }
}
